import React from 'react'
import { Outlet } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import PlatFormMenu from '../common/PlatFormMenu'

const PrivateLayout = () => {
  return (
    <div className="min-h-screen background-gradient relative">
      <header className="h-fit pt-9 mx-16 pb-0 hidden md:flex justify-between items-center">
        <div className="w-fit">
          <a href="/">
            <img src="/images/logo.png" alt="Logo" className="w-64" />
          </a>
        </div>
        <div>
          <PlatFormMenu />
        </div>
      </header>
      <div className="md:hidden absolute z-50 top-4 left-4">
        <PlatFormMenu color="white" />
      </div>

      <main className="md:mx-16 md:my-4">
        <AnimatePresence>
          <Outlet />
        </AnimatePresence>
      </main>

      <footer className="h-24 hidden md:block"></footer>
    </div>
  )
}

export default PrivateLayout
